import { withStyles } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core';
import RowsPerPageSelect from './RowsPerPageSelect';

const styles = () => createStyles({});

export default withStyles(styles)(RowsPerPageSelect);
